import { render, staticRenderFns } from "./user-variables.vue?vue&type=template&id=dd89ede0&scoped=true"
import script from "./user-variables.vue?vue&type=script&lang=js"
export * from "./user-variables.vue?vue&type=script&lang=js"
import style0 from "./user-variables.vue?vue&type=style&index=0&id=dd89ede0&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd89ede0",
  null
  
)

export default component.exports